import React, { useState } from "react";
import bannerImg from "../img/banner.avif";
import logoimg from "../img/logo.svg";

const STATIC_USER = "invoice@parkengage.com";
const STATIC_PASSWORD = "invoiceGen2026!";
const SESSION_DURATION = 60 * 60 * 1000; // 1 hour
const MAX_USERS = 3;

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const cleanExpiredSessions = () => {
    const sessions = JSON.parse(localStorage.getItem("active_sessions")) || [];
    const now = Date.now();

    const validSessions = sessions.filter(
      (session) => session.expiry > now
    );

    localStorage.setItem("active_sessions", JSON.stringify(validSessions));
    return validSessions;
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (
      username.trim() !== STATIC_USER ||
      password.trim() !== STATIC_PASSWORD
    ) {
      alert("Invalid Credentials");
      return;
    }

    // Clean old sessions first
    let sessions = cleanExpiredSessions();

    if (sessions.length >= MAX_USERS) {
      alert("Maximum 3 users already logged in");
      return;
    }

    const expiry = Date.now() + SESSION_DURATION;

    const newSession = {
      id: Math.random().toString(36).substring(2),
      expiry,
    };

    sessions.push(newSession);

    localStorage.setItem("active_sessions", JSON.stringify(sessions));
    localStorage.setItem("auth", JSON.stringify(newSession));

    window.location.replace("/invoice");
  };

  return (
    <div className="grid w-screen h-screen grid-cols-1 bg-center bg-cover md:grid-cols-3">

      <img
        src={bannerImg}
        alt="Login Background"
        className="absolute inset-0 object-cover w-full h-full -z-10"
      />

      <div className="flex flex-col items-center justify-center gap-3 relative bg-white/90 z-10 backdrop-blur-lg px-10 pt-10">

        <div className="w-full max-w-md">

          <form
            className="flex flex-col gap-4"
            onSubmit={handleLogin}
          >
            <img
              src={logoimg}
              alt="Parkengage Logo"
              className="h-20"
            />

            <p className="text-gray-500 text-center">
              Login to your account
            </p>

            <input
              type="email"
              placeholder="login@parkengage.com"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-4 rounded-lg border border-gray-200 focus:outline-none bg-white focus:ring-2 focus:ring-blue-500 transition text-gray-700"
              required
            />

            <input
              type="password"
              placeholder="*********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-4 rounded-lg border border-gray-200 focus:outline-none bg-white focus:ring-2 focus:ring-blue-500 transition text-gray-700"
              required
            />

            <button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-4 rounded-lg transition duration-200 shadow-md mt-6"
            >
              Login
            </button>
          </form>

        </div>
      </div>

      {/* Right Panel */}
      <div className="relative flex-col hidden w-full col-span-2 p-10 md:flex md:items-center md:justify-end">
        <div className="bg-black/40 p-8 rounded w-full max-w-[500px] flex flex-col gap-4 backdrop-blur-lg">
          <h1 className="text-3xl text-white">
            We are <span className="font-bold text-blue-400">Parkengage</span>
          </h1>
          <p className="text-sm italic text-white">
            Innovative parking solutions for modern challenges.
          </p>
        </div>
      </div>

    </div>
  );
}

export default Login;